import { api } from 'common';

import {
  FilterProps,
  RowWithPadding,
  StyledRow,
  updateFilterParams,
} from './common';

import { Checkbox, Typography } from '@vivaahealth/design-system';

interface Props extends FilterProps {
  supportedLocations?: api.PrevisitProvider.SupportedLocationMap;
}

const LocationsFilter: React.FC<Props> = ({
  embedded,
  filterOptions,
  organizationId,
  params,
  pathname,
  setFilterOptions,
  setCurrentPage,
  supportedLocations,
}) => {
  if (!supportedLocations) {
    return null;
  }
  return (
    <div>
      <RowWithPadding>
        <Typography variant="title-medium" bold className="ps-0">
          Locations
        </Typography>
      </RowWithPadding>
      {Object.keys(supportedLocations).map((location) => {
        const checked = filterOptions.locations?.includes(location);
        const count = supportedLocations[location];
        return (
          <StyledRow key={location}>
            <Checkbox
              label={`${location} (${count})`}
              small
              checked={checked ?? false}
              onChange={(event) => {
                const updatedLocations = updateFilterParams({
                  checked: event.target.checked,
                  embedded,
                  filterItem: location,
                  organizationId,
                  paramString: 'location',
                  params,
                  pathname,
                });
                setFilterOptions({
                  ...filterOptions,
                  locations: updatedLocations,
                });
                setCurrentPage?.(1);
              }}
            />
          </StyledRow>
        );
      })}
    </div>
  );
};

export default LocationsFilter;
